import { useEffect, useState } from "react";
import { ReactComponent as UserPlus } from "../../Assets/images/UserPlus.svg";
import { ReactComponent as Plus } from "../../Assets/icon/Plus-big.svg";
import { useNavigate } from "react-router-dom";
import "./style.css";

const EmptyState = ({ onAddClick }) => {
  const [isLoading] = useState(false);
  const navigate = useNavigate(); // React Router's hook for navigation

  // Pending requests removed; no API call needed

  // Handle navigation
  const routeToAddReq = () => {
    const queryParams = new URLSearchParams();
    queryParams.append("isPendingRequest", "true");
    window.location.href = `/manageRelationship?${queryParams.toString()}`;
  };

  return (
    <>
      <div className="content">
        <div className="profile-container">
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <div className="circle-wrapper">
              <div className="circle-add circle-1"></div>
              <div className="circle-add circle-2"></div>
              <div className="circle-add circle-3"></div>
              <UserPlus className="profile-image" />
            </div>
            <h2 style={{ marginBottom: "16px" }}>Add a connection</h2>
            <p className="add-relationship-para">There is no one in your circle yet.</p>
            <button className="add-person-btn" onClick={onAddClick}>
              <Plus /> Add Person
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmptyState;
